import * as React from "react";
import { Button, Link } from "@chakra-ui/react";

import { FaTwitter, FaInstagram, FaDiscord } from "react-icons/fa";

export const Social = () => {
  return (
    <>
      <Link href="https://twitter.com/Trogoneofficiel" isExternal>
        <Button
          bg="transparent"
          _hover={{ background: "tranparent" }}
          _active={{ background: "tranparent" }}
          size="md"
          borderRadius="16px"
        >
          <FaTwitter color="white" size="20px" />
        </Button>
      </Link>
      <Link href="https://www.instagram.com/trogoneofficiel/" isExternal>
        <Button
          bg="transparent"
          _hover={{ background: "tranparent" }}
          _active={{ background: "tranparent" }}
          size="md"
          borderRadius="16px"
        >
          <FaInstagram color="white" size="20px" />
        </Button>
      </Link>
      <Link href="https://discord.gg/DrzrZaXZCe" isExternal>
        <Button
          bg="transparent"
          _hover={{ background: "tranparent" }}
          _active={{ background: "tranparent" }}
          size="md"
          borderRadius="16px"
        >
          <FaDiscord color="white" size="20px" />
        </Button>
      </Link>
    </>
  );
};
